module.exports = __webpack_public_path__ + "img/power_on.ebe62021.png";